import AddTalentToJob from './AddTalentToJob.component';

export default AddTalentToJob;
